<template>
	<v-row
		dense
		no-gutters
		justify = "center"
		align   = "center"
	>
		<v-col
			xl 	 = "12"
			lg 	 = "12"
			md 	 = "12"
			sm 	 = "12"
			xs 	 = "12"
			cols = "12"
		>
			<v-card 
				outlined				
			>
				<v-card-title
					class = "grey secondary subtitle-1 pa-0 body- white--text justify-center"
				>
					<v-icon
						
						color  = "success"
						v-text = "'mdi-vector-intersection'" 
						class  = "mx-2"
					></v-icon>

					<span
						class ="text-uppercase"
						v-text = "$ml.get(head.title)"
					></span>
					<!-- <v-chip 
						small 
						color  = "success"
						class  = "mx-2 text-uppercase"
						v-show = "head.title1"
					>  {{ head.title1 }} </v-chip> -->


					<!-- <v-spacer></v-spacer> -->
					
					<v-icon 
						small 
						color 	= "white"
						class 	= "ml-1"
						@click 	= "$router.back()"
						v-show  = "false" 
					>
						mdi-arrow-left-circle
					</v-icon>
					
				
				</v-card-title>
				<v-card-text
					class = "pt-1 pa-1"
				>
					<v-row>
						
						<v-col 
							cols 	= "4"
							v-show 	= "show.add"
						>
							<v-card 
								outlined

							>
								<v-card-title
									class = "pa-0 pl-2  primary body-2 white--text"
								>
									<span
									>
										{{ sub_title }}										
									</span>
									
									<v-spacer></v-spacer>

								</v-card-title>	
								<v-card-text
									class = "pa-1 "
								>
								<form>
								<v-row
									no-gutters
									justify = "center"
									align 	= "center"
								>	
									<template
										v-for = "(item_field, idx_field) of info_fields "
										
									>			
										
									<!-- v-if  = "item_field.enable"			 -->
										<v-col 
											cols = "11"
											:key = "idx_field"
										>
											<v-text-field
												dense
												outlined
												hide-details
												v-if 		 = "item_field.type == 'text' || item_field.type == 'number' || item_field.type == 'password' "
												v-model 	 = "info[item_field.key]"
												:label  	 = "$ml.get(item_field.text)"
												:type 		 = "item_field.type"
												class 		 = "mt-2"
												v-show 		 = "item_field.enable"
												:placeholder = "item_field.placeholder ? $ml.get(item_field.placeholder) : ''"
												@click 		 = "$Helper.keyboard_is_active(item_field.key, ID_notification, 'obj', 'info', info[item_field.key])"	
												autocomplete        = "false"
											></v-text-field>
												<!-- @input 	= "v => { v = input[item_field.key] }" -->
												<!-- :disabled = "item_field.enable"								 -->
												<!-- @input  = "v => { info[item_field.key] = v.toUpperCase()}"		 -->
											
											<v-select
												dense
												outlined
												hide-details
												v-if 		= "item_field.type == 'select'"
												v-show 		= "item_field.enable"												
												:label 		= "$ml.get(item_field.text)"
												v-model 	= "info[item_field.key]"
												:items 		= "render_listeds(item_field.list)"
												:item-text  = "item_field.item_text"
												:item-value = "item_field.value" 
												class 		= "my-2"
												@input 		= "render_input(item_field.key)"
											>
												<!-- return-object -->
												<!-- multiple -->
												<template v-slot:selection="{ item, index }">
											        <v-chip x-small 
											        	v-if = "index < 3">
											          <span>{{ item }}</span>
											        </v-chip>
											        <span
											          v-if  = "index == 4"
											          class = "grey--text caption"
											        >
											          (+{{ info[item_field.key].length - 3 }} others)
											        </span>
											      </template>
											</v-select>
										</v-col>
									</template>
								</v-row>
								</form>

								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-spacer></v-spacer>

									<v-progress-circular
								      	indeterminate
								      	color  = "primary"
								      	v-show = "show_progress"
								    	:size  = "20"
								    	:width = "4"
								    ></v-progress-circular>

									<v-btn
										x-small
										v-show 		= "!show_progress"
										color  		= "primary"										
										@click 		= "actions(btn_action)"
										:disabled 	= "!required_info"
									>
										{{ $ml.get(btn_action) }}
									</v-btn>
									<v-btn
										x-small
										color 	  =  "error"
										:disabled = "btn_action == 'update' ? false : true"
										v-text    = "$ml.get('delete')"						
										@click    = "actions('confirm_delete')"
									></v-btn>
								</v-card-actions>
							</v-card>
						</v-col>
						<v-col
							v-show = "show.add"
						>
							<v-toolbar
					    		dense
					    		height = "25"
					    		class  = "secondary white--text"
					    	>
					    		<v-icon
									small
									color = "white"
									class = "mr-1"
								>
									mdi-view-list
								</v-icon>
					    		<v-toolbar-title 
					    			class = "body-2"
					    		>
					    			{{ $ml.get(head.table_dev) }}
					    		</v-toolbar-title>
					    			
					    	</v-toolbar>
							
							<v-divider></v-divider>

							<v-data-table
								dense
							    fixed-body
							    show-select
							    fixed-header
								class 				 = "elevation-5"
								:items 				 = "devices"
								:headers 			 = "header_table_dev"
								:options.sync 		 = "options_dev"
							   	:server-items-length = "total_dev"
							   	loading-text 		 = "Loading... Please wait"
							   	:loading 			 = "loading_dev"
							    item-key 			 = "id"
							    v-model 			 = "selection_devices"
							    :height  			 = "(layout_height - 200) + 'px'"
							    :single-select  	 = "isSingle_select_dev"
							   	:footer-props  		 = "{
							   		// showFirstLastPage 	: true,
							   		itemsPerPageOptions : [/*15, 30*/],
							   		showCurrentPage 	: true,
							   		itemsPerPageText 	: ''
							   	}"
							   	
							>
								<template
									v-slot:item.create_motion = "{ item, index }"
								>
									<v-btn
										small										
										:color = "item.create_motion ? 'primary' : 'secondary'"
										@click = "actions('set_create_motion', item, index)"
									>
										{{ item.create_motion ? $ml.get("on") : $ml.get("off") }}
									</v-btn>
								</template>
							</v-data-table>
						</v-col>
						<v-col
							cols = "12"
						>

							<v-toolbar
					    		dense
					    		height = "25"
					    		class  = "secondary white--text"
					    	>
					    		<v-icon
									small
									color = "white"
									class = "mr-1"
								>
									mdi-view-list
								</v-icon>
					    		<v-toolbar-title 
					    			class = "body-2"
					    		>
					    			{{ $ml.get(head.table)}}
					    		</v-toolbar-title>
					    			<v-spacer></v-spacer>
					    			<v-btn
					    				x-small
					    				fab
					    				height 	= "23"
					    				width 	= "25"
					    				:color  = "!show.add ? 'primary' : 'error'"
					    				@click 	= "actions('show')"
					    				v-show 	= "show.add_integration"

					    			>
					    				<v-icon
					    					small
					    					class = "pa-0 ma-0"
					    				>

					    					{{ !show.add ? 'mdi-plus' : 'mdi-close' }} 
					    				</v-icon>
					    			</v-btn>
					    	</v-toolbar>
							
							<v-divider></v-divider>

							<v-data-table
								dense
							    fixed-body
							    fixed-header
								class 				 = "elevation-5"
								:items 				 = "render_list"
								:headers 			 = "header_table"
								:options.sync 		 = "options"
							   	:server-items-length = "total"
							   	loading-text 		 = "Loading... Please wait"
							   	:loading 			 = "loading"
							    item-key 			 = "id"
							    :height  			 = "layout_height + 'px'"
							   	:footer-props  		 = "{
							   		showFirstLastPage 	: true,
							   		itemsPerPageOptions : [15, 30],
							   		showCurrentPage 	: true,
							   		itemsPerPageText 	: ''
							   	}"
							   	
							>
							    <!-- rowsPerPageText: [30] -->
								<template v-slot:item.actions="{ item }" >
									<v-btn
										x-small
										color  = "primary"
										@click = "actions('edit', item)"
										v-show = "show.edit_integration"
									>
										<v-icon
											x-small
											
										>
											mdi-pencil
										</v-icon>
									</v-btn>	
									<v-btn
										x-small
										color  = "error"
										@click = "actions('confirm_delete', item)"
										v-show = "show.delete_integration"
									>
										<v-icon
											x-small
											
										>
											mdi-delete
										</v-icon>
									</v-btn>							
								</template>
								<template v-slot:item.createdAt = "{ item }" >								
									{{ item.date }} 
								</template>
								<template v-slot:item.manager_id = "{ item }" >
									<v-chip 
										x-small
										:color = "!item.manager_id ? 'secondary' : 'success'"
									>
										<span>											
											{{ item.manager_id ? item.manager_id : $ml.get('data_no_found') }} 
										</span>
									</v-chip>
								</template>
								
							</v-data-table>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
	import EventBus from '@/event-bus'
	export default{
		name : 'integration_cloud',
		data : (vm) => ({
			info 	: {},
			input 	: {},
			head 	: {
				title  		: 'integration_config',
				title1 		: 'lpr',
				table  		: 'registered_integrations',
				table_dev 	: 'registered_devices'
			}, 
			info_fields : [
 				{ // 0
					key  		: 'type_integrate',
					text 		: 'type_integrate',
					type 		: 'select',
					list 		: [
						'cloud',
						'module', 
						'streaming', 
						'guardian_cloud', 
						'external_client', 
						'mqtt', 
						'telegramAPI', 
						'Sera4', 
						'tecnoparking',
						'ViolationCloud',
						'CitizenFaceAPI' 
					],
					enable 		: true,
					/*value  : '',
					item_text   : ''*/
 				},
				{ // 1
					key  		: 'type_encode_media',
					text 		: 'type_encode_media',
					type 		: 'select',
					list 		: ['base64', 'multipart'],
					enable 		: false,
					/*value  : '',
					item_text   : ''*/
 				},
				{ // 2
					key  		: 'manager_id',
					text 		: 'manager',
					type 		: 'text',
					list 		: "devices",
					enable 		: false,
				},
				
				{ // 3
					key  		: 'ip_address',
					text 		: 'ip_address',
					type 		: 'text',
					enable 		: true,
				},
				{ // 4
					key  		: 'name',
					text 		: 'name',
					placeholder : "name_cloud_msg",

					type 		: 'text',
					enable 		: false,
				},
				{ // 5
					key  		: 'port_socket',
					text 		: 'port_socket',
					placeholder : "port_socket_msg",
					type 		: 'number',
					enable 		: false,
				},
				{ // 6
					key  		: 'name',
					text 		: 'password',
					placeholder : "password",
					type 		: 'password',
					enable 		: false,
				},
				{ // 7
					key  		: 'username',
					text 		: 'username',
					placeholder : "username",
					type 		: 'text',
					enable 		: false,
				},
				{ // 8
					key  		: 'password',
					text 		: 'password',
					placeholder : "password",
					type 		: 'password',
					enable 		: false,
				},
				{ // 9
					key  		: 'site',
					text 		: 'site',
					placeholder : "site",
					type 		: 'text',
					enable 		: false,
				},
				{ // 10
					key  		: 'method',
					text 		: 'method',
					type 		: 'select',
					list 		: ['GET', 'POST','DELETE','PUT'],
					enable 		: false,
				},
				

				

			],
			show : {
				add 				: false,
				add_integration 	: true,
				edit_integration 	: true,
				delete_integration 	: true,
			},
			sub_title : vm.$ml.get('register'),
			
			show_progress : false,
			btn_action 	  : 'save',
			header_table  : [
				{ text: vm.$ml.get('manager'), value: 'manager_id', align: 'center' },
				{ text: vm.$ml.get('ip_address'), value: 'ip_address', align: 'center' },
				{ text: vm.$ml.get('type_integrate'), value: 'type_integrate', align: 'center' },
				{ text: vm.$ml.get('type_encode_media'), value: 'type_encode_media', align: 'center' },
				{ text: vm.$ml.get('date'), 'value': 'createdAt', align: 'center'},
				{ text: vm.$ml.get('actions'), value: 'actions', align: 'center'}
			],
			header_table_dev  : [
				{ text: vm.$ml.get('name'), value: 'name' },
				{ text: vm.$ml.get('create_motion'), value: 'create_motion' },				
				{ text: vm.$ml.get('type'), value: 'type' },
				// { text: vm.$ml.get('actions'), value: 'actions', align: 'center'}
			],
			options 	  : { itemsPerPage : 30 },
			total 		  : 0,
			layout_height : 400,
			ID_notification : 'listing_details',
			loading 	  : false,
			list_lists 	  : [],
			list 		  : [], 
			required_info : true,
			list_profiles : [],
			bus 		  : {},
			isSingle_select_dev : false,
			selection_devices 	: [],
			options_dev  		: {},
			total_dev   		: 0,
			loading_dev 		: false, 
			list_devs 			: vm.$store.getters["Devices/list"],
			

		}), // data

		created(){
			if (this.$route.name == 'list_face') {
				this.head.title1 = 'face';
				this.header_table.splice(0, 1, { text : this.$ml.get('entity'), value : 'entity' })
			}
			let obj_new =  this.$Helper.set_property_obj(this.info_fields);
			if (obj_new) {
				this.info = obj_new;
			}
			// this.get_listing()
			// this.get_profiles();

			let modul = this.$store.getters["auth/permission"](this.$route.name || "settings", "", "settings");
			if (modul) {
				if (!modul.can_add ) { this.show.add_integration = false };
				if (!modul.can_edit) { this.show.edit_integration = false };
				if (!modul.can_delete) { this.show.delete_integration = false };
			}
				
		}, // created

		watch : {
			options : { 
				handler(){
					this.get_list();
				}, deep : true
			}, // options			
		
		}, // watch

		computed : {
			
			render_list : function(){
				return this.list;
			}, // render_list

			devices : function(){
				if (this.list_devs && this.list_devs.length) {
					this.total_dev 	= this.list_devs.length;
				}else {
					this.total_dev 	= 0;
				}
				return this.list_devs;
			}, // devices

		}, // computed

		methods : {
			actions(act, item, opt) {
				// console.log(" actions integration ", act, item, opt);
				if (act == 'show') {
					this.show.add = !this.show.add;
					if (this.btn_action == 'update' || this.btn_action == 'save') {
						this.actions('clear_info');
					}
				}
				if ( act == 'clear_info') {
					this.btn_action = 'save';
					this.info 		= {};
					this.info_item  = {};
					this.sub_title 	= this.$ml.get('register');
					this.render_input('type_integrate');

				}
				if (act == 'save') {
					this.save();
				}
				if (act == 'update') {
					this.save(true);
				}
				if (act == 'edit') {
					this.info 		= { ...item };
					// this.info_item 	= this.list.indexOf(item);
					this.render_input('type_integrate');

					this.show.add 	= true;
					this.sub_title 	= this.$ml.get('update');
					this.btn_action = 'update';
					this.info_item  = item;
					if (item && item.devices && item.devices.length > 0) {
						this.selection_devices = item.devices;
					}

				}
				if ( act == 'confirm_delete') {
					this.info_item = { ...item };

					EventBus.$emit('notifications_modal',{
						type  : 'confirm_delete',
						ID 	  : this.ID_notification,
					});
				}else
				if (act == 'set_create_motion') {				
					item.create_motion = !item.create_motion;			
					const idx = this.list_devs.findIndex(x => x && x.id == item.id);
					if (idx >= 0) {
						this.list_devs.splice(idx, 1, {...item});
					}
					
				}
			}, // actions

			render_listeds(list){
				if (this[list]) {
					return this[list];
				}else{
					return list;
				}

			}, // render_list

			get_list(){
				const { itemsPerPage, page } = this.options;
				const api 	 = this.$URL + '/api/v1/cloud/?page=' + page;
				this.loading = true;
				
				this.$axios.get(api).then( res => {
					// console.log(res, 'res get_list');
					let items = res.data.rows;
					if (items && items.length > 0) {
						items.forEach((list_item) =>{
							if (list_item) {
								let temp = this.format_info(list_item);
								if (temp){
									list_item = temp; 
								}
							}
						})
					}
					this.total 	 = res.data.count;
					this.list  	 = [ ...items];
					this.loading = false;

				}).catch( er => {
					this.loading = false;					
					console.log(er, 'Error get_list');
					let  err = er && er.message ? er.message : er;
						

					this.$EventBus.$emit('notifications_modal',{
						type  	: 'error',
						message :  err
					});
				})

			}, // get list
			
			get_listing(){
				
				// const { itemsPerPage, page } = this.options;
				let pg 		= 1;
				let vm 		= this;
				const api 	= this.$URL + '/api/v1/cloud/?page=' + pg;
				// this.loading = true;
				
				this.$axios.get(api).then( res => {
					console.log(res, 'res get_list');
					let items 	  = res.data.rows;
					// this.total = res.data.count;
					let temp_list = [];

					if (items && items.length > 0) {
						items.forEach((item_list) => {
							if (item_list && item_list.name && vm.head.title1 == item_list.type) {
								temp_list.push(item_list);
							}
						})
					}
					console.log(" LISTS : ", temp_list, items)
					if (temp_list && temp_list.length > 0) {

						this.list_lists  	= [ ...temp_list ];
						this.required_info 	= true;
					}else{
						this.$EventBus.$emit('notifications_modal', {
							type 	: 'warning',
							message : ' Required have list created : go to lists'
						})
					}
					// this.loading = false;

				}).catch( er => {
					// this.loading = false;					
					console.log(er, 'Error get_list');
					let err = er && er.message ? er.message : er;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'warning',
						message : 'Failed Get de lists : ' + err
					})
				})
			}, // get listing

			save(up){
				if (up) {
					if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_edit", "settings")){
						this.$EventBus.$emit("notifications_modal",{
							type 	: "warning",
							message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("settings"),
						});
						return false;
					};
				}else{
					if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_add", "settings")){
						this.$EventBus.$emit("notifications_modal",{
							type 	: "warning",
							message : this.$ml.get("no_have_permission_create") + " : " + this.$ml.get("settings"),
						});
						return false;
					};
				}
				let opt 	= 'post';
				let info_up = { ...this.info };
				let api 	= this.$URL + '/api/v1/cloud';
				let check  	= false;
				let msg 	= ''; 
				info_up["devices"] = this.selection_devices;
				if (info_up.type_integrate == "tecnoparking") {
					info_up.type_encode_media 	= "base64";


					if (this.selection_devices && this.selection_devices.length > 0) {
						info_up.manager_id 			= this.selection_devices[0].deviceId;
					}else{
						this.$EventBus.$emit("notifications_modal",{
							type 	: "warning",
							message : this.$ml.get("req_sel_device"),
						});
						return null;
					}
				}else if(info_up.type_integrate == "ViolationCloud"){
					info_up.type_encode_media 	= "base64";
				}
				if (info_up.type_integrate == "CitizenFaceAPI") {
					info_up.type_encode_media 	= "base64";

				}
				this.loading = true;

				if (up) {
					opt = 'put';					
					msg = 'Not found id'
					if (info_up && info_up.id ) {
						api   += '/' + info_up.id;
						check  = true;
						msg    = '';
					}
				}else{
					check = true;
				}

				/*if (!info_up.listId) {
					check = false;
					msg   = this.$ml.get('require_sel_list')
				}*/
				if (check) {
					this.$axios[opt](api, info_up).then( res => {
						console.log('res ', opt, 'list setting', res );
						this.$EventBus.$emit('notifications_modal',{
							type : up ? 'updated' : 'saved', 
						});
						this.loading = false;
						// this.$router.back();
						if (!up) { // save
							this.total ++;
							let info_res = this.format_info(res.data);
							this.list.push(info_res);
						}else{
							let idx = this.list.indexOf(this.info_item);
							// console.log("update list : ", idx)
							// this.info_item = info_up;
							if (idx >= 0) {
								this.list.splice(idx, 1, info_up);
							}
						}
			    		this.info_fields[2].enable 	= false;
			    		this.selection_devices 		= [];

						if (this.show.add) {
							this.actions('show');
						}
					}).catch(er => {
						this.loading = false;						
						console.log("Error list setting ", opt, er);
						let  err 	 = up ? 'update ' : 'save ';
						err 	 	+= er && er.message ? er.message : er;

						this.$EventBus.$emit('notifications_modal',{
							type  	: 'error',
							message :  err
						});

					})

				}else{
					this.$EventBus.$emit('notifications_modal',{
						type  	: 'error',
						message :  msg
					});
					this.loading = false;

				}
			}, // save

			del(item){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_delete", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_delete") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				if (item) {
					if (item.id) {
						this.loading = true;
						const api 	 = this.$URL + '/api/v1/cloud/' + item.id;
						this.$axios.delete(api).then(res =>{
							this.$EventBus.$emit('notifications_modal',{
								type : 'deleted', 							
							});
							/*let idx = this.list.findIndex(x => (x && x.id == item.id)); // indexOf
							if (idx >= 0) {
								this.list.splice(idx, 1);
							}
							if (this.list && this.list.length === 0) {
								this.total = 0;
							}else{
								this.total = this.list && this.list.length == 1 ? 1 : this.list.length - 1;
							}*/
							this.get_list();
							this.loading   = false;							
							if (this.show.add) {
								this.actions('show');
							}
						}).catch( er => {
							console.log( "Error deleting ", er);
							this.loading = false;
							let  err 	 = up ? 'update ' : 'save ';
							err 		+= er && er.message ? er.message : er;
							this.$EventBus.$emit('notifications_modal',{
								type  	: 'error',
								message :  'Deleting item ' + err
							});
						})
					}else{
						this.$EventBus.$emit('notifications_modal',{
							type  	: 'warning',
							message :  'Item to delete have id'
						});	
					}
				}else{
					this.$EventBus.$emit('notifications_modal',{
						type  	: 'warning',
						message :  'Item to delete null'
					});
				}
			}, // del item

			format_info(item){
				if (item){
					if (item.listId) {
						let temp_lists = this.list_lists[this.list_lists.findIndex( x => x.id == item.listId)] ;						
						item.list = temp_lists ? temp_lists.name : false;
						
					}		
					if (item.createdAt) {
						item.date  = this.$momentz(item.createdAt).format('ll, LTS');
					}
					return item;			
				}
				return null
			}, // format info

			render_input(key){
				if (key == 'type_integrate' && this.info[key]){
					console.log("key : ", key,this.info[key])
					this.info_fields[3].text 		= "ip_address";
					this.info_fields[4].text 		= "name";
		    		this.info_fields[3].placeholder	= "name_cloud_msg";
					this.info_fields[5].text 		= "port_socket";
					this.info_fields[5].placeholder = "port_socket_msg"
					this.isSingle_select_dev 		= false;


					if(this.info[key] == 'cloud'){
			    		this.info_fields[1].enable 	= true;
		    			this.info_fields[2].enable  = true;
		    			this.info_fields[4].enable 	= false;
			    		this.info_fields[5].enable 	= false;
			    		this.info_fields[6].enable 	= false;
			    		this.info_fields[7].enable 	= false;			    			
			    		this.info_fields[8].enable 	= false;

			    		delete this.info.name;
						delete this.info.port_socket;
			    	}
			    	else{
			    		this.info_fields[2].enable 	= false;
		    			delete this.info.name;
						delete this.info.port_socket;
						delete this.info.type_encode_media;
						delete this.info.username;
						delete this.info.password;
			    		if (this.info.manager_id) {
			    			delete this.info.manager_id;
			    		}
			    		if (["module"].includes(this.info[key])) {
			    			this.info_fields[1].enable 	= true;
			    		}else{
			    			this.info_fields[1].enable 	= false;

			    		}
			    		if (this.info[key] == "guardian_cloud") {
			    			this.info_fields[4].enable 	= true;
			    			this.info_fields[5].enable 	= true;
			    			this.info_fields[6].enable 	= false;
			    			this.info_fields[7].enable 	= false;			    			
			    			this.info_fields[8].enable 	= false;
			    			
			    		}else 
			    		if (this.info[key] == "external_client"){
			    			this.info_fields[4].enable 	= false;			    			
			    			this.info_fields[5].enable 	= true;
			    			this.info_fields[6].enable 	= true;
			    			this.info_fields[7].enable 	= false;			    			
			    			this.info_fields[8].enable 	= false;
			    			

			    		}else if(this.info[key] == "mqtt"){
			    			this.info_fields[1].enable 	= false;			    			
			    			this.info_fields[2].enable 	= false;			    			
			    			this.info_fields[3].enable 	= true;	 // ip_address		    			
			    			this.info_fields[3].text 	= "broker_address";
			    			this.info_fields[4].enable 	= false;			    		
			    			this.info_fields[5].enable 	= true; // port_socket
			    			this.info_fields[5].text 	= "broker_port";
			    			this.info_fields[5].placeholder = "";
			    			this.info_fields[6].enable 	= false;			    			
			    			this.info_fields[7].enable 	= true;	// 		 username   			
			    			this.info_fields[8].enable 	= true;	// 		 password	    			

			    		}else if(this.info[key] == "telegramAPI"){
			    			this.info_fields[1].enable 	= false;			    			
			    			this.info_fields[2].enable 	= false;			    			
			    			this.info_fields[3].enable 	= true;	 // ip_address		    			
			    			this.info_fields[3].text 	= "telegramAPI";
			    			this.info_fields[4].enable 	= false;			    		
			    			this.info_fields[5].enable 	= false;
			    			this.info_fields[6].enable 	= false;			    			
			    			this.info_fields[7].enable 	= false;			    			
			    			this.info_fields[8].enable 	= false;			    			
			    		}else if(this.info[key] == "Sera4"){
			    			this.info_fields[1].enable 	= false;			    			
			    			this.info_fields[2].enable 	= false;			    			
			    			this.info_fields[3].enable 	= false;	 // ip_address		    			
			    			this.info_fields[3].text 	= "Sera4";
			    			this.info_fields[4].enable 	= false;			    		
			    			this.info_fields[5].enable 	= false;
			    			this.info_fields[6].enable 	= false;			    			
			    			this.info_fields[7].enable 	= false;			    			
			    			this.info_fields[8].enable 	= false;
							this.info_fields[9].enable 	= true;			    			
			    		}else if (this.info[key] == "tecnoparking") {
			    			this.info_fields[1].enable 		= false;			    			
			    			this.info_fields[2].enable 		= false;			    			
			    			this.info_fields[3].enable 		= true;	 // ip_address		 
			    			this.info_fields[3].placeholder	= "ip_address";	 // ip_address		 
			    			this.info_fields[4].enable 		= true;
							this.info_fields[4].placeholder = "name";
							this.isSingle_select_dev 		= true;
							this.selection_devices 			= [];									    		
			    			this.info_fields[5].enable 		= false;
			    			this.info_fields[6].enable 		= false;			    			
			    			this.info_fields[7].enable 		= false;			    			
			    			this.info_fields[8].enable 		= false;


			    		}else if(this.info[key] == "ViolationCloud"){
							this.info_fields[1].enable 		= false;
							this.info_fields[3].enable 		= true;
							this.info_fields[3].placeholder	= "endpoint";
							this.info_fields[4].enable 		= true;
							this.info_fields[4].placeholder = "name";
							this.info_fields[10].enable 	= true;
							this.info_fields[10].placeholder = "method";
							this.info_fields[6].enable 	= false;
							this.info_fields[7].enable 	= false;
							

						}else if (this.info[key] == "CitizenFaceAPI") {
							this.info_fields[1].enable 		= false;
							this.info_fields[3].enable 		= true;
							this.info_fields[3].placeholder	= "endpoint";
							this.info_fields[4].enable 		= false;
							this.info_fields[4].placeholder = "name";
							this.info_fields[8].enable 	= true;
							this.info_fields[8].placeholder 	= "token";
							this.info_fields[10].enable 	= true;
							this.info_fields[10].placeholder = "method";
						}
			    		else{
			    			this.info_fields[4].enable 	= false;
			    			this.info_fields[5].enable 	= false;
			    			this.info_fields[6].enable 	= false;
			    			this.info_fields[7].enable 	= false;			    			
			    			this.info_fields[8].enable 	= false;
			    			
			    		}
			    		
			    	}
				}else{
					// this.info_fields[2].enable = false;
				}
			}

		}, // methods

		mounted(){
			let temp_bus = 'notifications_modal' + this.ID_notification; 
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) => {
				if (action) {
					this.del(this.info_item);
				}
			}); 
			temp_bus = 'keyboard_type' + this.ID_notification;
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					console.log("INPUT TYPE : ",action)
					if (action.setting ) {
						let { obj, key, type, func } =  action.setting;
						if ( action.input || action.input == "") {

							if (type == 'text') {
								if (func == 'toUpperCase') {
									this[key] = action.input[func]();

								}else{
									this[key] = action.input;
								}
							}else{
								// console.log("obj key ", this[obj][key], action.input)
								this[obj][key] = action.input;
								
							}
						}
						 
					}
				}
			});
			temp_bus = 'keyboard_type_button' + this.ID_notification;
			EventBus.$on( temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					if (action.setting ) {
						let { obj, key, type, func } =  action.setting;
						// console.log("SEARCH EVENT 1", action.button == "{enter}", type, key)

						if (action.button == '{enter}') {
							if (type == 'text' && key == 'search') {
								// console.log("SEARCH EVENT")
								// this.get_search(this.search);
							}

						}
					}
				}
			})
		}, // mounted

		beforeDestroy(){
			this.$Helper.clear_bus(EventBus, this.bus, 'integration_cloud');

		}, // beforeDestroy

	}; // export default
</script>